import { Navigation, Swiper } from 'swiper';

export default function BaseCompositionPageListGallery(elm: HTMLDivElement, slidesPerViewOnLargeScreen: number) {
  const options = {
    modules: [
      Navigation
    ],
    lazy: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    spaceBetween: 20,
    breakpoints: {
      800: {
        slidesPerView: slidesPerViewOnLargeScreen
      },
      520: {
        slidesPerView: 2
      },
      0: {
        slidesPerView: 1
      }
    }
  };

  return new Swiper(elm, options);
}